// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 85 ? "pages-step1" : chunkId) + "." + {"60":"e70baef7","85":"03dd8936"}[chunkId] + ".chunk.js";
};